(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('new-contribution', {
            parent: 'home',
            url: '/new-contribution',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: false});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('home.new-profile', {
            parent: 'home',
            url: '/contribution-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
             resolve: {
                entity: function () {
                    return {
                        name: null,
                        id: null
                    };
                }
            },
             views: {
              'contrib@': { 
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })
        .state('home.new-company', {
            parent: 'home',
            url: '/contribution-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        logo: null,
                        logoContentType: null,
                        id: null
                    };
                }
            },
            views: {
              'contrib@': { 
                templateUrl: 'app/entities/company/company-dialog.html',
                controller: 'CompanyDialogController',
                controllerAs: 'vm'
              }
            }
        })
        .state('home.new-collectivity', {
            parent: 'home',
            url: '/contribution-collectivity',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        city: null,
                        collectivitySize: null,
                        id: null
                    };
                }
            },
            views: {
              'contrib@': { 
                templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                controller: 'CollectivityDialogController',
                controllerAs: 'vm'
              }
            }
        })

    }
})();
